'use strict';

// ⚠ .cjs 는 webpack 이 babel 없이 직접 파싱한다 → `??` / `?.` 금지 (production 빌드가 깨진다). 기존 .cjs 헬퍼들과 같은 제약.

// /v3/scoring 은 df_subs(업체 답변행)에서 출발하므로 답변 0건 업체는 items 가 빈 배열이라 평가요소 자리가 안 뜬다.
// GET /v3/scoring/slots (캠페인 템플릿 기준, sub_id null) 로 자리를 먼저 만들고, scoring 결과가 있는 문항은 sub_code 단위로 통째로 덮어쓴다.
//
// 기계평가가 없는 슬롯은 not_applicable/satisfied 가 null 인데 화면은 boolean 을 전제한다
// (EvaluationComponent_v2#is_not_applicable 이 null 을 "같은 문항 내 값 불일치 오류"로 취급해 저장 버튼을 잠근다).
// /v3/scoring 은 항상 boolean 을 주므로 슬롯도 같은 기본값(false)으로 맞춘다.
function mergeEvSlots(slotItems, scoringItems) {
    const mapEv = {};
    (slotItems || []).forEach(ev => {
        mapEv[ev.sub_code] = {
            ...ev,
            ev_results: (ev.ev_results || []).map(r => ({
                ...r,
                not_applicable: r.not_applicable == null ? false : r.not_applicable,
                satisfied: r.satisfied == null ? false : r.satisfied,
            })),
        };
    });
    (scoringItems || []).forEach(ev => {
        mapEv[ev.sub_code] = ev;
    });
    return mapEv;
}

module.exports = { mergeEvSlots };
